import apiClient from './api';
import { AccountStatementDto } from '../types/accountStatement.types';

export const accountStatementService = {
  getAccountStatement: async (
    accountId: number,
    costCenterId: number | null,
    fromDate: string,
    toDate: string
  ): Promise<AccountStatementDto> => {
    const params = new URLSearchParams({
      accountId: accountId.toString(),
      fromDate: fromDate,
      toDate: toDate,
    });

    if (costCenterId !== null) {
      params.append('costCenterId', costCenterId.toString());
    }

    const response = await apiClient.get(`/Reports/AccountStatement?${params.toString()}`);
    return response.data.data;
  },
};